import { render, staticRenderFns } from "./Topics.vue?vue&type=template&id=fe3f1320"
import script from "./Topics.vue?vue&type=script&lang=js"
export * from "./Topics.vue?vue&type=script&lang=js"
import style0 from "./Topics.vue?vue&type=style&index=0&id=fe3f1320&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports